<!--
 * @Author: your name
 * @Date: 2021-04-09 16:19:37
 * @LastEditTime: 2021-05-06 17:41:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/blogger/bzList/add.vue
-->
<template>
  <div class="blogger-add" v-loading="loading">
    <div class="information">
      <h4 class="title">基础信息</h4>
      <el-form :model="basicForm" :rules="rules" ref="basicForm" size="small" :disabled="true">
        <div class="form-block">
          <el-form-item style="width:23%;" label="博主名称" prop="name" class="block-form-item w-25">
            <el-input @blur="nameblur" v-model="basicForm.name" placeholder="输入博主名称"></el-input>
          </el-form-item>
          <el-form-item style="width:23%;" label="总互动量" prop="interactNum" class="block-form-item w-25">
            <el-input maxlength="30" v-model="basicForm.interactNum" placeholder="输入总互动量"></el-input>
          </el-form-item>
          <el-form-item style="width:23%;" label="性别" prop="gender" class="block-form-item w-25" >
            <el-select style="width:100%;" v-model="basicForm.gender" clearable placeholder="未选择">
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:23%;" label="所在城市" prop="areaId" class="block-form-item w-25">
            <el-cascader style="width:100%;" v-model="basicForm.areaId" placeholder="选择所在地域" :options="regionList" clearable filterable change-on-select></el-cascader>
          </el-form-item>
          <el-form-item style="width:23%;" label="结算方式" prop="settlementMethod" class="block-form-item w-25" >
            <el-select style="width:100%;" v-model="basicForm.settlementMethod" clearable placeholder="未选择" @change="changeTag()">
              <el-option label="固定比例" :value="0"></el-option>
              <el-option label="阶梯比例" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:23%;" label="税率" prop="taxRate" class="block-form-item w-25">
            <el-input maxlength="30" v-model="basicForm.taxRate" placeholder="输入税率"></el-input>
          </el-form-item>
        </div>
        <div :class="[
          'form-block',
          'has-divider',
          operateType !== 'show' ? 'bottom' : '',
        ]" v-show="showTag">
          <h4 class="title">阶梯分成比例</h4>
          <el-divider class="divider"></el-divider>
          <div class="block-main">
            <el-table :data="basicForm.divideList" class="cost-table" size="mini">
              <el-table-column label="起始金额(元)">
                <template slot-scope="scope">
                  <el-form-item :prop="`divideList.${scope.$index}.startMoney`" :rules="rules.startMoney">
                    <el-input size="small" type="text" v-model="scope.row.startMoney"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="结束金额（元）">
                <template slot-scope="scope">
                  <el-form-item :prop="`divideList.${scope.$index}.endMoney`" :rules="rules.endMoney">
                    <el-input size="small" type="text" v-model="scope.row.endMoney"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="分成比例（%）">
                <template slot-scope="scope">
                  <el-form-item :prop="`divideList.${scope.$index}.divideRate`" :rules="rules.divideRate">
                    <el-input size="small" type="text" v-model="scope.row.divideRate"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column width="74" align="center" class-name="operate-column">
                <template slot="header" slot-scope="scope">
                  <el-button v-if="operateType !== 'show'" type="primary" size="mini" icon="el-icon-plus" @click="onAddCost">新增</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button v-if="
                      operateType !== 'show' && basicForm.divideList.length > 1
                    " type="danger" size="mini" icon="el-icon-delete" circle @click="onRemoveCost(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-if="$route.query.id">
          <el-form-item label="资源分类" class="prop-item">
            <div v-if="categoryNameList">
              <el-tag style="margin-right:10px;" v-for="(item,index) in categoryNameList" :key="index">{{item}}</el-tag>
            </div>
            <div v-else style="color:#CCC;font-size:14px;">暂无分类</div>
          </el-form-item>
        </div>
        <el-form-item label="博主头像" style="width:100px;" class="avatar-upload-wrap">
          <el-upload class="avatar-uploader" :action="'https://upload-z2.qiniup.com'" :name="'avatar-image'" :show-file-list="false" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload"
            :accept="'image/gif, image/jpeg, image/jpg, image/png'">
            <img v-if="basicForm.avatar" :src="basicForm.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="博主简介" class="prop-item">
          <el-input type="textarea" :rows="5" v-model="basicForm.introduction"  maxlength="500" show-word-limit placeholder="输入博主简介"></el-input>
        </el-form-item>
        <el-form-item label="合作品牌" class="prop-item">
          <el-input type="textarea" :rows="5" v-model="basicForm.cooperationBrand"  maxlength="500" show-word-limit placeholder="输入合作品牌"></el-input>
        </el-form-item>
      </el-form>
      <div class="addAccount">
        <h4 class="title">关联账号</h4>
      </div>
      <div class="account_box">
        <div class="account_list" v-for="(item,index) in accountList" :key="index">
          <div class="list_left">
            <div style="width:30px;height:30px;">
              <img v-if="item.mediaType == 2" style="width:100%;height:100%;" src="@/assets/img/wb.png" alt="">
              <img v-if="item.mediaType == 3" style="width:100%;height:100%;" src="@/assets/img/xhs.png" alt="">
              <img v-if="item.mediaType == 5" style="width:100%;height:100%;" src="@/assets/img/bz.png" alt="">
              <img v-if="item.mediaType == 6" style="width:100%;height:100%;" src="@/assets/img/ks.png" alt="">
              <div v-if="item.mediaType == 1" class="typeImgWx"></div>
              <div v-if="item.mediaType == 7" class="typeImgTb"></div>
              <div v-if="item.mediaType == 4" class="typeImgDy"></div>
            </div>
            <div class="val_left">
              <div style="width:50px;height:50px;margin-right:10px;">
                <img v-if="item.avatar" style="width:100%;height:100%;border-radius: 50px;" :src="item.avatar" alt="">
                <img v-else style="width:100%;height:100%;border-radius: 50px;" src="/img/media/weibo_default.png">
              </div>
              <div>
                <el-tooltip :content="item.name" placement="top" effect="light">
                  <div class="accountName">{{item.name}}</div>
                </el-tooltip>
                <div>{{item.fansNum}}</div>
              </div>
            </div>
          </div>
          <div style="color:#999;" class="el-icon-delete" @click="closeClick(item,index)"></div>
        </div>
      </div>
      <el-form :model="assessForm" ref="assessForm" :rules="assessRules" label-position="top">
        <div class="form-block has-divider top bottom">
          <h4 class="title">审批信息</h4>
          <el-divider class="divider"></el-divider>
          <div class="block-main">
            <template>
              <el-form-item label="审批状态" prop="status" class="block-form-item w-99">
                <el-select v-model="assessForm.status" @change="statusChange">
                  <el-option label="审批通过" value=1></el-option>
                  <el-option label="审批不通过" value=0></el-option>
                </el-select>
              </el-form-item>
              <approve-pay-list :approveObj="approveObj" v-if="approveObj"></approve-pay-list>
              <el-form-item v-if="assessForm.status == 0" label="原因" prop="notPassReason" class="block-form-item w-99">
                <el-input type="textarea" maxlength="300" show-word-limit v-model="assessForm.notPassReason"></el-input>
              </el-form-item>
            </template>
            <el-form-item label="审批备注" prop="auditRemark" class="block-form-item w-99">
              <el-input type="textarea" maxlength="300" show-word-limit v-model="assessForm.auditRemark"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-block-submit">
          <el-button type="primary" size="small" @click="onSubmitAssess" :disabled="assessSubmitLoading">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>


<script>
import { mediaConfig } from "@/const/config/media";
import { getRegionList } from "@/api/media/support";
import * as qiniu from "qiniu-js";
import validate from "@/util/validate";
import { qiniuToken } from "@/api/index";
import { listAllMedia } from "@/api/business/contract";
import { bloggerDetail } from "../api";
import { assessBlogger } from "@/api/approve/blogger";
import approvePayList from "@/components/common/approvePayMember";
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载
export default {
  components: {
    approvePayList,
  },
  data() {
    var validCategory = (rule, value, callback) => {
      let leng =  this.GetLength(value)
      if(leng/2>12){
        callback(new Error("博主名称不能大于12个字符,（2个英文字符=1个中文字符）"));
      }else{
        callback()
      }
    };

    var validPrice = (rule, value, callback) => {
      if (!validate.checkNull(value)) {
        let err = validate.checkMoney(value, 100000000);
        if (err) {
          callback(new Error(err));
        }
        callback();
      }
      callback();
    };

    return {
      kongList:[],
      loading:false,
      accountList:[],
      operateType:'edit',
      mediaConfig: mediaConfig,
      mediaTableLoading: false,
      mediaTable: [],
      selectMediaList: [],
      disableMediaCheckbox: [],
      categoryNameList:[],
      mediaListModal:false,
      mediaPage: {
        queryString:"",
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      regionList: [],
      basicForm: {
        name: "",
        gender:"",
        interactNum:"",
        avatar:"", //头像
        introduction:"",//简介
        cooperationBrand:"",//合作品牌
        areaId:null,//地区ID
        mediaList:[],//关联账号
        settlementMethod:"" ,//结算方式
        taxRate:"" ,//税率
        divideList: [],//阶梯分成比例

      },
      approveObj:"",
      showTag:false , 
      //审批
      assessForm: {
        status: "1",
        notPassReason: "",
        auditRemark: "",
      },
      assessRules: {
        status: [
          { required: true, message: "请选择审批状态", trigger: "change" },
        ],
        notPassReason: [
          { required: true, message: "请输入审批不通过原因", trigger: "blur" },
        ],
      },
      assessSubmitLoading: false,
      rules: {
        name: [
          { required: true, message: '请输入博主名称', trigger: 'blur' },
          { validator: validCategory, trigger: "blur" },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        settlementMethod: [{ required: true, message: "请选择结算方式", trigger: "change" }],
        startMoney: [{ validator: validPrice, trigger: "blur" }],
        endMoney: [{ validator: validPrice, trigger: "blur" }],
        divideRate: [{ validator: validPrice, trigger: "blur" }],
        taxRate: [{ required: true, message: '请输入税率', trigger: 'blur' }],
      }
    };
  },
  methods: {
    changeInput(){
      var pattern = /^[1-9][0-9]*$/ // 正整数的正则表达式
      // 不符合正整数时
      if (!pattern.test(this.basicForm.interactNum)) {
        // input 框绑定的内容为空
        this.basicForm.interactNum = ''
      }
    },
    changeTag(){
      this.showTag = this.basicForm.settlementMethod ;
      this.basicForm.divideList=[];
    },
    GetLength(str) {
      var realLength = 0,
          len = str.length,
          charCode = -1;
      for (var i = 0; i < len; i++) {
          charCode = str.charCodeAt(i);
          if (charCode >= 0 && charCode <= 128) realLength += 1;
          else realLength += 2;
      }
      return realLength;
    },
    addAccountClick(){
      this.mediaPage.queryString = "",
      this.mediaListModal = true;
      this.mediaPage.pageNum = 1;
      this.getMediaList();
      this.selectMediaList = this.accountList.slice()
    },
    nameblur(){
      bloggerNameCheck({
        bloggerName:this.basicForm.name,
        id:this.$route.query.id
      }).then(res=>{
      }).catch(res=>{
        this.basicForm.name = ""
      })
    },
    //编辑进入
    editDetails(){
      // this.loading = true;
      bloggerDetail({
        id:this.$route.query.id
      }).then(res=>{
        this.basicForm = res.data;
        this.accountList = res.data.mediaAccountList
        this.selectMediaList = res.data.mediaAccountList
        // 地址处理
        if (this.basicForm.areaId && typeof this.basicForm.areaId == "string") {
          this.basicForm.areaId = this.basicForm.areaId.split(",");
          this.basicForm.areaId = this.basicForm.areaId.map((item, index) => {
            return parseInt(item);
          });
        }
        // this.basicForm.areaId = JSON.parse(res.data.areaId)
        this.categoryNameList = res.data.categoryNameList
        this.loading = false;
        this.showTag = this.basicForm.settlementMethod ;
      })
    },
    //提交
    submitSave(){
      this.$refs['basicForm'].validate((valid) => {
        if (valid) {
          if(this.basicForm.areaId){
            this.basicForm.areaId = JSON.stringify(this.basicForm.areaId)
            this.basicForm.areaId = this.basicForm.areaId.replace(/\[|]/g,'')
          }else{
            this.basicForm.areaId = null
          }
          this.basicForm.mediaList = this.accountList ;

          //接口请求
          bloggerSave(this.basicForm).then(res=>{
            if(res.code === 1){
              this.$message.success(`提交成功!`);
              setTimeout(() => {
                this.$router.push({ path: `/blogger/blogger` });
              }, 500)
            }
            if (this.basicForm.areaId && typeof this.basicForm.areaId == "string") {
              this.basicForm.areaId = this.basicForm.areaId.split(",");
              this.basicForm.areaId = this.basicForm.areaId.map((item, index) => {
                return parseInt(item);
              });
            }
            // this.basicForm.areaId = JSON.parse(this.basicForm.areaId)
          })
        } else {
          return false;
        }
      });
    },

    //结案审批状态改变
    statusChange(val) {
      this.assessForm.notPassReason = "";
    },

    //审批
    onSubmitAssess() {
      this.$refs.assessForm.validate((valid) => {
        if (valid) {
          let obj = {};
          obj.id = this.$route.query.id;
          obj.isPass = parseInt(this.assessForm.status);
          obj.notPassReason = this.assessForm.notPassReason; //审批失败原因
          obj.auditRemark = this.assessForm.auditRemark;
          this.assessSubmitLoading = true;
          assessBlogger(obj)
            .then((res) => {
              this.assessSubmitLoading = false;
              //判断钉钉环境审批
              if(dd.env.platform!="notInDingTalk"){
                this.$store.state.common.isSuccessView = 1
                location. reload()
                this.$router.go(0)
              }else{
                this.$message.success("审批成功");
                let router = this.$router.push({
                  path: "/check/blogger",
                });
                window.open(router.href);
                window.open("about:blank","_self").close()
                window.close();//关闭当前页面
              }

            })
            .catch((error) => {
              this.assessSubmitLoading = false;
            });
        }
      });
    },

    //资源弹窗关闭
    onConfirmMediaChoose() {
      this.accountList = this.selectMediaList.slice()
      this.mediaListModal = false;
    },
    //资源搜索
    onMediaSearch() {
      this.mediaPage.pageNum = 1;
      this.getMediaList();
    },
    //获取资源列表
    getMediaList() {
      let obj = {
        pageSize: this.mediaPage.pageSize,
        pageNum: this.mediaPage.pageNum,
        queryString:this.mediaPage.queryString
      };
      this.mediaTableLoading = true;
      listAllMedia(obj)
        .then((res) => {
          this.mediaTable = res.data || [];
          this.mediaPage.total = res.total;
          this.mediaTableLoading = false;

          this.$nextTick(() => {
            this.mediaTable.forEach((item) => {
              let selected =
                this.selectMediaList.findIndex(
                  (v) =>
                    v.mediaId == item.mediaId && v.mediaType == item.mediaType
                ) !== -1;
              this.$refs.mediaSelectTable.toggleRowSelection(item, selected);
            });
          });
        })
        .catch((err) => {
          this.mediaTable = [];
          this.mediaPage.total = 0;
          this.mediaTableLoading = false;
        });
    },
    /**
     * @param val 当前值
     * @param row 被选中/取消选中的对象
     */
    onSingleSelect(val, row) {
      let index = this.selectMediaList.findIndex(
        (v) => v.mediaId == row.mediaId && v.mediaType == row.mediaType
      );
      if (index === -1) {
        this.selectMediaList.push(row);
      } else {
        this.selectMediaList.splice(index, 1);
      }
    },
    /**
     * 获取表格行id
     * @param row
     */
    getRowKeys(row) {
      return row.mediaId + "_" + row.mediaType;
    },
    /** 全选 */
    onAllSelect(val) {
      let other = [], //其他页数据
        current = []; //本页数据
      this.selectMediaList.forEach((v) => {
        if (
          this.mediaTable.findIndex(
            (v1) => v1.mediaType == v.mediaType && v1.mediaId == v.mediaId
          ) === -1
        ) {
          other.push(v);
        } else {
          current.push(v);
        }
      });
      let mediaPageValid = this.mediaTable.filter(
        (v) =>
          this.disableMediaCheckbox.findIndex(
            (v1) => v1.mediaType == v.mediaType && v1.mediaId == v.mediaId
          ) === -1
      );
      let mediaPageUnval = this.mediaTable.filter(
        (v) =>
          this.disableMediaCheckbox.findIndex(
            (v1) => v1.mediaType == v.mediaType && v1.mediaId == v.mediaId
          ) !== -1
      );
      let nonSelectArr = mediaPageValid.filter(
        (v) =>
          this.selectMediaList.findIndex(
            (v1) => v1.mediaType == v.mediaType && v1.mediaId == v.mediaId
          ) === -1
      );
      if (nonSelectArr.length > 0) {
        this.mediaTable.forEach((v) => {
          let index = this.selectMediaList.findIndex(
            (v2) => v2.mediaId == v.mediaId && v2.mediaType == v.mediaType
          );
          if (index === -1) {
            this.selectMediaList.push(v);
          }
        });
      } else {
        this.selectMediaList = [...other, ...mediaPageUnval];
      }
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    mediaSizeChange(val) {
      this.mediaPage.pageNum = 1;
      this.mediaPage.pageSize = val;
      this.getMediaList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    mediaCurrentChange(val) {
      this.mediaPage.pageNum = val;
      this.getMediaList();
    },
    /**
     * 资源是否能被删除
     * @param item 标签元素
     */
    isMediaClosable(item) {
      if (
        this.operateType === "edit" &&
        this.disableMediaCheckbox.find(
          (v) => v.id == item.id && v.mediaId == item.mediaId
        )
      ) {
        return false; //禁用
      } else {
        return true;
      }
    },
    /**
     * 资源标签类型
     * @param item 标签元素
     */
    isMediaCloseType(item) {
      if (
        this.operateType === "edit" &&
        this.disableMediaCheckbox.find(
          (v) => v.mediaType == item.mediaType && v.mediaId == item.mediaId
        )
      ) {
        return "info"; //禁用
      } else {
        return "primary";
      }
    },
    /**
     * 资源标签删除
     * @param item 标签元素
     */
    onMediaTagClose(item,type) {
      let index = this.selectMediaList.findIndex(
        (v) => v.mediaId == item.mediaId && v.mediaType == item.mediaType
      );
      let tbItem = this.mediaTable.find(
        (v) => v.mediaId == item.mediaId && v.mediaType == item.mediaType
      );
      if (index !== -1) {
        this.selectMediaList.splice(index, 1);
        this.$refs.mediaSelectTable.toggleRowSelection(tbItem, false);
      }
    },
    closeClick(item,index){
      this.accountList.splice(index, 1);
    },
    /**
     * 头像上传
     * @param file 需要上传的文件
     */
    beforeUpload(file) {
      let imgTypes = ["image/jpg", "image/jpeg", "image/gif", "image/png"];
      if (imgTypes.indexOf(file.type) === -1) {
        this.$message.warning("请上传正确格式图片，支持jpg/jpeg/gif/png");
        return;
      }
      if (file.size > 100 * 1024 * 1024) {
        this.$message.warning("图片文件大小不大于100M");
        return;
      }
      qiniuToken()
        .then((res) => {
          let that = this;
          var observable = qiniu.upload(file, Date.now() + file.name, res.data);
          observable.subscribe({
            next(res) {
              console.log("upload...", res); //res.total.percent;
            },
            error(error) {
              console.log("error", error);
            },
            complete: (complete) => {
              let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
              that.basicForm.avatar = qiniuBaseUrl + complete.key;
              that.$forceUpdate();
            },
          });
        })
        .catch((error) => {});
      return false;
    },
    // 上传图片成功
    uploadSuccess(res, file) {
      // file 返回的文件信息，也可以在这里调用七牛上传。
      console.log(file, "success");
    },
    // 上传图片失败
    uploadError(res, file) {
      console.log("error", res, file);
    },

    //添加成本统计
    onAddCost() {
      this.basicForm.divideList.push({
        startMoney :"" ,
        endMoney : "" ,
        divideRate : "" ,
      });
    },
    /**
     * 删除成本统计
     * @param index 待删除成本统计索引
     */
    onRemoveCost(index) {
      this.basicForm.divideList.splice(index, 1);
    },
  },
  computed: {},
  watch:{
    '$route.path':function(o,n){
      if(o=='/blogger/bzList/add'){
        this.accountList = []
        this.basicForm = {
          name: "",
          gender:"",
          interactNum:"",
          avatar:"", //头像
          introduction:"",//简介
          cooperationBrand:"",//合作品牌
          areaId:null,//地区ID
          mediaList:[],//关联账号
          settlementMethod:"" , //结算方式
        }
      }
    }
  },
  mounted() {
    //查询城市
    getRegionList().then((res) => {
      this.regionList = res.data || [];
    });
    //编辑进入
    if(this.$route.query.id){
      this.editDetails()
    }else{
      this.loading = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.table-con{
  height: 500px;
  overflow: auto;
}
.blogger-add {
  padding: 20px;
  font-size: 14px;
}
.information {
  background: #fff;
  min-height: 100px;
  padding: 20px;
}
.title {
  margin: 5px 0;
  font-size: 14px;
  padding-right: 20px;
}
.formTop{
  padding: 20px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.form-block {
  position: relative;
  padding-bottom: 20px;

  .bottom-divider {
    position: absolute;
    left: -15px;
    right: -15px;
    bottom: 0;
    height: 10px;
    background: #f0f2f5;
    box-shadow: 0 2px 12px 0 rgb(220, 222, 226) inset;
  }

  .title {
    margin: 5px 0;
    font-size: 14px;
  }
  .divider {
    margin: 8px 0 10px;
  }

  &-submit {
    padding-top: 15px;
    text-align: center;
  }

  .block-form-item {
    &.w-25 {
      display: inline-block;
      width: 24%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-50 {
      display: inline-block;
      width: 49%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-99 {
      width: 99%;
      margin-right: 1%;
    }
  }
}
.addAccount{
  margin-top: 30px;
  display: flex;
  align-items: center;
}
.account_box{
  margin-top:20px;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  -webkit-flex-wrap: wrap;
}
.account_list{
  width: 240px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border:1px solid #EFEFEF;
  padding: 0 10px;
  border-radius: 8px;
  margin:5px;
}
.list_left,.val_left{
  display: flex;
  align-items: center;
}
.val_left{
  padding-left:10px;
}

.typeImgWx{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
}
.typeImgTb{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -180px;
}
.typeImgDy{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -90px;
}
.accountName{
  width: 107px;
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
}



// 头像
/deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 108px;
  height: 108px;
  line-height: 108px;
  text-align: center;
}
.avatar {
  width: 108px;
  height: 108px;
  display: block;
}

.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 100%;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
/deep/.select-con {
  .el-tag .el-icon-close {
    top: -1px !important;
  }
}
</style>
